var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"font-weight-regular"},[_vm._v(_vm._s(_vm.getLabel()))]),(_vm.isRequired)?_c('span',{staticClass:"is-required-tag ml-2 mr-2"},[_c('sup',[_vm._v("*")])]):_c('span',{staticClass:"mr-2"})])}
var staticRenderFns = []

export { render, staticRenderFns }